export const convertHcpToString = (hcp: number | null): string => {
  let hcpString = hcp?.toFixed(1) || ''
  if (hcp) {
    hcpString = hcp > 0 ? `+${hcpString}` : hcpString.replace('-', '')
  }
  return hcpString
}
